/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './related-data-traffic.component.html';

@Component({
  standalone: false,
  selector: 'adn-related-data-traffic',
  template
})
export class RelatedDataTrafficComponent {
  @Input() allStats: any;
  @Input() countType: any;
  @Input() relatedChartData: any;
  @Input() changeHook: any;
  @Input() chartType: string;
  @Input() osEmpty = false;
  @Input() mobileBrandEmpty = false;
  @Input() appEmpty = false;
  @Input() isSpecialUser = false;
  @Input() isPending = false;
}
